import { axiosObject } from "../config";

export default function initiateGoogleLogin() {
  return new Promise((resolve, reject) => {
    let uri = "access/login/google";

    let payload = {
      redirect_to: process.env.NEXT_PUBLIC_GOOGLE_REDIRECT_URL,
    };
    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
